import { render, staticRenderFns } from "./bindStaff.vue?vue&type=template&id=4e675b10&scoped=true&"
import script from "./bindStaff.vue?vue&type=script&lang=js&"
export * from "./bindStaff.vue?vue&type=script&lang=js&"
import style0 from "./bindStaff.vue?vue&type=style&index=0&id=4e675b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e675b10",
  null
  
)

export default component.exports